import { ApolloProvider } from '@apollo/client'
import { useApolloClient } from '@/lib/useApolloClient'

import { useAuth } from '@/components/unholster/react-authkit'

function ApolloProviderComponent({ children }: Readonly<{ children: React.ReactNode }>) {
  const auth = useAuth()
  const client = useApolloClient(auth.setStatusCode)
  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default ApolloProviderComponent
